import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store/store'
import './registerServiceWorker'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueGeolocation from 'vue-browser-geolocation';

Vue.config.productionTip = false

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAIDdf82NHO64i78UKsj3-BI0vW3KVHg9k", // Test or everything?
    libraries: 'places', // This is required if you use the Autocomplete plugin
  },
})
Vue.use(VueGeolocation);

import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

import config from './config.js'
firebase.initializeApp(config.firebaseConfig)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


firebase.auth().onAuthStateChanged(() => {
  const currentUser =  firebase.auth().currentUser
  if (currentUser && currentUser != null) {
      console.log('AUTH CHANGE Current User is now:' + currentUser.uid)
      store.dispatch('locations/loadUid', currentUser)
      store.dispatch('admin/loadIsAdmin', currentUser)

  }
  // if (currentUser) {
  //   // Set it in the store
  //   const uid = currentUser.uid
  //   store.commit('admin/setUID', {uid})
  // } else {
  //   const nullUID = { uid : null }
  //   store.commit('admin/setUID', nullUID)
  // }
})


// Load the Vue devtools to enable inspection.
// This is useful in both dev, test and sometimes in prod!
import devtools from '@vue/devtools'
if (process.env.NODE_ENV === 'development') {
  console.log("LOADING Devtools in main.js...")
  devtools.connect(/* host, port */)
}
// devtools.connect(/* host, port */)
